import { Component, inject, input } from '@angular/core';
import { AufgabenTyp } from '@schir-int-client/aufgabe-shared';
import { CreateAufgabeFormService } from '../../create-aufgabe-dialog/create-aufgabe.formservice';

type AllowedAufgabenTyp = AufgabenTyp.WIEDERVORLAGE | AufgabenTyp.LFPR_WIEDERVORLAGE;

@Component({
	selector: 'schir-int-client-aufgabe-wiedervorlage-editor',
	templateUrl: './aufgabe-wiedervorlage-editor.component.html',
	styleUrls: ['./aufgabe-wiedervorlage-editor.component.scss'],
	standalone: false,
})
export class AufgabeWiedervorlageEditorComponent {
	private readonly formService = inject(CreateAufgabeFormService);

	readonly aufgabenTyp = input.required<AllowedAufgabenTyp>();

	get formGroup() {
		return this.formService.form.controls[this.aufgabenTyp()];
	}

	get bodyControls() {
		return this.formGroup.controls.body.controls;
	}
}
